/* PupHush cart-drawer cross-sell ('Complete the calming ritual' cards). Self-contained, additive,
   degrades gracefully. Loaded by the PupHush PDP sections. Class prefix ph-dxs (drawer) to avoid
   colliding with the PDP on-page .ph-xsell styles. */
(function(){
  var HANDLES=['puphush-storm-kit','puphush-pressure-wrap','puphush-calming-den','puphush-calming-ear-snood'];
  var cache={},deb,suppress=false;
  function money(cents,cur){var a=(cents/100).toFixed(2);return cur==='EUR'?'€'+a.replace('.',','):(({USD:'$',GBP:'£'})[cur]||'$')+a;}
  function short(t){return t.split('—')[0].replace('PupHush™','').replace(/^The /,'').trim();}
  function fetchProduct(h){if(cache[h])return Promise.resolve(cache[h]);return fetch('/products/'+h+'.js',{headers:{Accept:'application/json'}}).then(function(r){return r.ok?r.json():null;}).then(function(p){cache[h]=p;return p;}).catch(function(){return null;});}
  function render(){
    fetch('/cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json();}).then(function(cart){
      var wrappers=[].slice.call(document.querySelectorAll('.cart-items__wrapper'));
      if(!wrappers.length)return;
      if(!cart||cart.item_count===0){[].slice.call(document.querySelectorAll('.ph-dxs')).forEach(function(e){e.remove();});return;}
      var inCart={};cart.items.forEach(function(i){inCart[i.handle]=1;});
      var picks=HANDLES.filter(function(h){return !inCart[h];}).slice(0,3);
      if(!picks.length){[].slice.call(document.querySelectorAll('.ph-dxs')).forEach(function(e){e.remove();});return;}
      Promise.all(picks.map(fetchProduct)).then(function(prods){
        prods=prods.filter(function(p){return p&&p.available;});
        if(!prods.length)return;
        var html='<p class="ph-dxs__title">Complete the calming ritual</p>';
        prods.forEach(function(p){
          var img=p.featured_image||(p.images&&p.images[0])||'';
          if(img&&img.indexOf('//')===0)img='https:'+img;
          if(img)img=img.replace(/(\.[a-z]{3,4})(\?|$)/,'_120x$1$2');
          var cmp=(p.compare_at_price&&p.compare_at_price>p.price)?'<s>'+money(p.compare_at_price,cart.currency)+'</s> ':'';
          html+='<a class="ph-dxs__card" href="'+p.url+'"><img src="'+img+'" alt="" width="56" height="56" loading="lazy"><span class="ph-dxs__info"><span class="ph-dxs__name">'+short(p.title)+'</span><span class="ph-dxs__price">'+cmp+money(p.price,cart.currency)+'</span></span><span class="ph-dxs__plus" aria-hidden="true">+</span></a>';
        });
        var key=cart.item_count+'|'+picks.join(',');
        suppress=true;
        try{
          wrappers.forEach(function(w){
            if(!w.parentNode)return;
            var box=w.parentNode.querySelector('.ph-dxs');
            if(box&&box.getAttribute('data-key')===key)return;
            if(!box){box=document.createElement('div');box.className='ph-dxs';w.parentNode.appendChild(box);}
            box.setAttribute('data-key',key);box.innerHTML=html;
          });
        }catch(e){}
        setTimeout(function(){suppress=false;},80);
      });
    }).catch(function(){});
  }
  function onMut(){if(suppress)return;clearTimeout(deb);deb=setTimeout(render,300);}
  function css(){
    if(document.getElementById('ph-dxs-css'))return;
    var s=document.createElement('style');s.id='ph-dxs-css';
    s.textContent='.ph-dxs{margin:10px 0;width:100%}.ph-dxs__title{font-size:12px;font-weight:600;letter-spacing:.4px;text-transform:uppercase;color:#6C5CB0;margin:0 0 8px}.ph-dxs__card{display:flex;align-items:center;gap:10px;padding:8px 10px;border:1px solid rgba(108,92,176,.22);border-radius:14px;background:#FBF8F3;text-decoration:none;margin-bottom:8px;transition:border-color .15s}.ph-dxs__card:hover{border-color:#6C5CB0}.ph-dxs__card img{width:56px;height:56px;border-radius:10px;object-fit:cover;flex-shrink:0}.ph-dxs__info{display:flex;flex-direction:column;gap:2px;min-width:0;flex:1}.ph-dxs__name{font-size:13px;font-weight:600;color:#28223C;line-height:1.25;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ph-dxs__price{font-size:12.5px;color:#574A93}.ph-dxs__price s{color:#B7B2C4;margin-right:2px}.ph-dxs__plus{width:26px;height:26px;border-radius:50%;background:#EF9F58;color:#fff;font-weight:700;font-size:16px;line-height:26px;text-align:center;flex-shrink:0}';
    document.head.appendChild(s);
  }
  function init(){
    css();
    var drawer=document.querySelector('cart-drawer-component, .cart-drawer');
    if(drawer){try{new MutationObserver(onMut).observe(drawer,{childList:true,subtree:true});}catch(e){}}
    ['cart:refresh','cart:update','cart:change','cart:added'].forEach(function(ev){document.addEventListener(ev,render);});
    render();
  }
  if(document.readyState!=='loading')init();else document.addEventListener('DOMContentLoaded',init);
})();
